import React, { useContext } from "react";

import { ImportContext } from "../../ImportContext";
import { MappingColumn } from "./MappingColumn";

export const MapSheetsAndColumns: React.FC = () => {
  const { selectedTemplate } = useContext(ImportContext);

  return (
    <div className="flex w-full gap-5">
      {selectedTemplate?.mappingSections.map((section, _, sections) => (
        <div
          key={section.key}
          className="bg-grey1 flex h-fit flex-col p-4"
          style={{ width: `${100 / sections.length}%`, maxWidth: "50%" }}
        >
          <MappingColumn section={section} />
        </div>
      ))}
    </div>
  );
};
